import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Features } from '../components/Features';
import { Helmet } from 'react-helmet-async';
export function RedditPage() {
  return <>
      <Helmet data-id="element-466" data-mp="2shfwf8m61sqy">
        <title data-id="element-467" data-mp="2shpdg6p8gpki">Build Games for Reddit - Fifth Door</title>
        <meta name="description" content="Create a game and publish it to Reddit in minutes. No coding required." data-id="element-468" data-mp="2xd4pct3okbea" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-469" data-mp="24psbr8fhzdx4" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-470" data-mp="24q2432o0lx5z" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-471" data-mp="2enycvnthcg0x" />
        <script data-id="element-472" data-mp="3q2lnm7dzemif">
          {`
            !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init yi Fr Mr mi Rr Or capture Li calculateEventProperties Dr register register_once register_for_session unregister unregister_for_session zr getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Nr jr createPersonProfile Ur Tr Hr opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ar debug L Lr getPageViewId captureTraceFeedback captureTraceMetric $r".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
            posthog.init('phc_jETIRcaQQ5wwKvb9mxnRwHnNeXlgXBbTtVWc0NYToYa', {
              api_host: 'https://us.i.posthog.com',
              defaults: '2025-05-24',
              person_profiles: 'identified_only'
            })
          `}
        </script>
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-473" data-mp="1ugotku5zbc78">
        {/* Background Effects */}
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-474" data-mp="248kq40sf2u9c" />

        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-475" data-mp="1lfgwgff78heq" />

        {/* Logo - Top Left Absolute Position */}
        <div className="absolute top-8 left-8 z-20" data-id="element-476" data-mp="1bgag59zgvfm8">
          <Link to="/" className="flex items-center gap-3" data-id="element-477" data-mp="1ffi5r8nkblzf">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-478" data-mp="1fi4br3ut1tfj" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-479" data-mp="1uc8yiz2qdzg2">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        {/* Content */}
        <div className="relative z-10 px-6 py-20 md:py-32 max-w-5xl mx-auto text-center" data-id="element-480" data-mp="2376wwlone4es">
          <div className="flex justify-center mb-8" data-id="element-481" data-mp="282m5ay3vz83t">
            <div className="inline-flex items-center px-8 md:px-10 py-2 rounded-full" style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(4px)'
          }} data-id="element-482" data-mp="2d4l8a6vps308">
              <p className="text-sm font-normal flex items-center gap-2" style={{
              color: 'rgba(255, 255, 255, 0.8)',
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-483" data-mp="2d9av730a7d62">
                <span className="w-2 h-2 rounded-full bg-[#FF4500]" data-id="element-484" data-mp="35x6lnpz9c8ue"></span>
                Built for Reddit Communities
              </p>
            </div>
          </div>

          <h1 className="text-[50px] md:text-[74px] mb-6" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-485" data-mp="2w73ln5tpxumk">
            BUILD A GAME FOR
            <br data-id="element-486" data-mp="3jxr8qyc7gqtp" />
            <span style={{
            color: '#FF4500'
          }} data-id="element-487" data-mp="3jx7m54bm1e9c">
              REDDIT
            </span>{' '}
            IN MINUTES.
          </h1>

          <p className="text-xl md:text-2xl leading-relaxed mb-12 text-white/80 max-w-3xl mx-auto" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-488" data-mp="1mz0loiex5cvv">
            No coding required. Create, publish, and share your game directly
            with your favorite subreddits in minutes.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-24 w-full sm:px-0" data-id="element-489" data-mp="zbsic611wdwh">
            <a href="https://play.fifthdoor.com/create?utm_source=reddit" target="_blank" rel="noopener noreferrer" className="w-[90%] sm:w-auto px-8 py-3.5 rounded-full font-semibold text-[15px] transition-all duration-300 hover:opacity-90 hover:scale-105 flex items-center justify-center gap-2" style={{
            backgroundColor: 'white',
            color: '#074030',
            fontFamily: "'Instrument Sans', sans-serif"
          }} data-id="element-490" data-mp="146fxhea5zvye">
              Start Creating
            </a>
          </div>

          {/* Steps Grid */}
          <div className="grid md:grid-cols-3 gap-8 text-left mb-20" data-id="element-491" data-mp="mrlti7yx5z9m">
            <div className="p-8 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-492" data-mp="msws7tdicgtv">
              <div className="text-4xl mb-6" data-id="element-493" data-mp="vqqr9c2npokq">🛠️</div>
              <h3 className="text-2xl font-bold mb-4 text-white" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-494" data-mp="rq6tq7e68iy2">
                1. Build
              </h3>
              <p className="text-white/70 leading-relaxed" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-495" data-mp="10s6aqzp6rn10">
                Use our intuitive no-code tools to bring your game idea to life
                in minutes. No technical experience required.
              </p>
            </div>

            <div className="p-8 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-496" data-mp="2lnnfmfh4zoel">
              <div className="text-4xl mb-6" data-id="element-497" data-mp="2qfngqb8y0ncr">🚀</div>
              <h3 className="text-2xl font-bold mb-4 text-white" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-498" data-mp="2ve87zl67vwp2">
                2. Publish
              </h3>
              <p className="text-white/70 leading-relaxed" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-499" data-mp="22rdpgtsyn7e8">
                Publish your game. Grab your unique link and share it
                directly to your target subreddit.
              </p>
            </div>

            <div className="p-8 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-500" data-mp="3o1umhogzglqp">
              <div className="text-4xl mb-6" data-id="element-501" data-mp="1chd925nxvudy">🎮</div>
              <h3 className="text-2xl font-bold mb-4 text-white" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-502" data-mp="17fxrwoovu80u">
                3. Play
              </h3>
              <p className="text-white/70 leading-relaxed" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-503" data-mp="xoa3kwnmh73l">
                Watch the community engage. Players can jump right in without
                downloading anything.
              </p>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="relative z-10 bg-[#074030]" data-id="element-504" data-mp="etv0auua2s9y">
          <Features data-id="element-505" data-mp="2e3bekc3hhj8k" />
        </div>
      </main>

      <Footer data-id="element-506" data-mp="295jlvfv0lt3b" />
    </>;
}